import "core-js/modules/es.array.concat.js";
var count = 0;
var countByPrefix = {};
export function uniqueId(prefix) {
  if (prefix) {
    var prefixCount = countByPrefix[prefix] || 0;
    prefixCount++;
    countByPrefix[prefix] = prefixCount;
    return "lmig-".concat(prefix).concat(prefixCount);
  }
  count++;
  return "".concat(count);
}
export default uniqueId;